const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    // italiaThemeViewsConfig: {
    //   ...config.settings.italiaThemeViewsConfig,
    //   imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    // },
    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: undefined,
      siteSubtitle: undefined,
      parentSiteTitle: 'Regione Calabria',
      parentSiteURL: 'https://www.regione.calabria.it/',
      subsiteParentSiteTitle: undefined,
      arLoginUrl:
        'https://servizi.comune.vibovalentia.vv.it/rwe2/user_console_mypage.jsp?ELANG=it',
      userLoggedMenu: [
        {
          href: {
            it:
              'https://servizi.comune.vibovalentia.vv.it/rwe2/user_console_mypage.jsp?ELANG=it',
          },
          title: { it: 'Le mie richieste' },
          roles: [],
          className: 'link-areaPersonale',
        },
      ],
    },

    'volto-gdpr-privacy': {
      ...config.settings['volto-gdpr-privacy'],
      defaultPanelConfig: null,
    },
  };

  return config;
};

export default applyConfig;
